import { styled } from '@mui/material';

export const StyledLessonTimePlaceholderDateWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '24px',
});
